module.exports = __webpack_public_path__ + "img/transport-3.9845841b.svg";